<template>
  <StaffLayout section="Staff Login">
    <div>
      <div class="flex flex-col justify-center min-h-600">
        <!-- component -->
        <div class="w-10/12 m-auto my-10 bg-white shadow-md lg:w-6/12 md:6/12">
          <div class="px-8 py-8 rounded-xl">
            <h1 name="login-title" class="mt-3 text-2xl font-medium text-center">Login to Staff</h1>
            <Loading v-if="isLoggingIn" />
            <ErrorDisplay
              label="Couldn't log in"
              :message="loginError"
              :isVisible="loginError != null"
            />
            <form action="" class="mt-6">
              <div class="my-5 text-sm">
                <label for="username" class="block text-black">Username</label>
                <input
                  id="username"
                  v-model="emailBox"
                  type="text"
                  autofocus
                  class="w-full px-4 py-3 mt-3 bg-gray-100 rounded-sm focus:outline-none"
                  placeholder="Username"
                  autocomplete="username"
                />
              </div>
              <div class="my-5 text-sm">
                <label for="password" class="block text-black">Password</label>
                <input
                  id="password"
                  v-model="passwordBox"
                  type="password"
                  autocomplete="current-password"
                  class="w-full px-4 py-3 mt-3 bg-gray-100 rounded-sm focus:outline-none"
                  placeholder="Password"
                />
                <div class="flex justify-end mt-2 text-xs text-gray-600">
                  <router-link
                    id="forgot-password"
                    title="forgot-password"
                    to="/staff/forgotpassword"
                  >
                    Forget Password?
                  </router-link>
                </div>
              </div>
              <div class="flex">
                <div class="flex-grow"></div>
                <button
                  id="login_button"
                  class="block w-40 p-3 text-center text-white duration-300 bg-gray-800 rounded-sm hover:bg-black"
                  @click.prevent="loginWithEmail"
                >
                  <!-- <icon-door-handle /> -->
                  Login
                </button>
              </div>
            </form>

            <div class="flex items-center justify-center mt-10 md:justify-between">
              <div style="height: 1px" class="hidden w-3/12 bg-gray-300 md:block"></div>
              <p class="text-sm font-light text-gray-400 md:mx-2">Login With External Account</p>
              <div style="height: 1px" class="hidden w-3/12 bg-gray-300 md:block"></div>
            </div>

            <div class="mt-8 flex">
              <div class="flex-grow"></div>
              <a
                :href="`/azuread/staff`"
                name="provider"
                value="okta"
                type="submit"
                class="w-40 p-4 text-center text-white duration-300 bg-blue-400 rounded-sm hover:bg-blue-500"
              >
                Microsoft
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </StaffLayout>
</template>

<script setup lang="ts">
import { useRouter, useRoute } from "vue-router";
import { useUserStore } from "../../store/userStore";

const userStore = useUserStore();
const router = useRouter();
const route = useRoute();

let errorObj = route.query["error"] as string | string[];

let errorParam: string =
  errorObj && Array.isArray(errorObj) ? errorObj[0] : errorObj?.toString() ?? "";

let loginError = ref<string | null>(errorParam ?? "");
let emailBox = ref("");
let passwordBox = ref("");
let isLoggingIn = ref(false);

async function loginWithEmail() {
  emailBox.value = emailBox.value.trim();
  console.log(`Attempting login for: ${emailBox.value}`);
  isLoggingIn.value = true;
  loginError.value = "";

  var returnUrls = route.query["returnUrl"];
  var returnUrl: string | null = null;
  if (returnUrls) {
    returnUrl = Array.isArray(returnUrls) ? returnUrls[0] : returnUrls;
    console.log(`Found returnUrl as '${returnUrl}' `);
  }

  if (!emailBox.value.endsWith("@akpreparedness.com")) {
    loginError.value = "Invalid Login User";
    console.warn("Only AK staff logins allowed");
    isLoggingIn.value = false;
    return;
  }

  let loginResult = await userStore.loginUser(
    emailBox.value,
    passwordBox.value,
    null,
    null,
    null,
    "staff"
  );

  if (loginResult && !loginResult.error && loginResult.person.token) {
    var token = loginResult.person?.token;
    if (token) {
      // One call covers every API client - the token is shared in ClientBase.
      userStore.setAuthToken(token);

      if (returnUrl && returnUrl.startsWith("/staff")) {
        router.replace(returnUrl);
      } else {
        router.replace("/staff");
      }
    }
  } else {
    console.warn(`Staff Login Failure`, loginResult);
    loginError.value = loginResult?.error ?? "Invalid Login";
    isLoggingIn.value = false;
  }
}
</script>
